export const ROLE_LABELS = { admin: "Amministratore", responsabile: "Responsabile", operatore: "Operatore", amministrazione: "Amministrazione" };

export const ROLE_HINTS = {
  admin: "Tutto, compresi documenti, impostazioni, registro e backup",
  responsabile: "Tutti gli appuntamenti, agenda, chat, impegnative e incassi",
  operatore: "Solo i propri appuntamenti, agenda, chat, impegnative e consegne",
  amministrazione: "Incassi e impegnative; appuntamenti in sola lettura",
};

export const can = (user, perm) => !!user?.perms?.includes(perm);
